import axios from 'axios'
import dayjs from 'dayjs'

export const useAmedasRank = (devDomains) => {
  const withDomain = devDomains?.site || 'https://site.weathernews.jp'
  const amedasElement = {
    気温: {
      getEndpoint: (month) => {
        return (month >= 4 && month <= 9) ? 'AIR_TEMP_1DAY_MAX' : 'AIR_TEMP_1DAY_MIN'
      },
      unit: '℃',
      rankLink: ''
    },
    降水量: { endpoint: 'RAIN_AMNT_1HOUR_TOTAL_1DAY_MAX', unit: 'mm', rankLink: 'precip/' },
    風: { endpoint: 'WIND_VEL_10MIN_MEAN', unit: 'm/s', rankLink: 'wind/' },
    降雪量: { endpoint: 'SNOW_AMNT_1HOUR_TOTAL_1DAY_MAX', unit: 'cm', rankLink: 'snow/' },
    湿度: { endpoint: 'AIR_HUM_1DAY_MIN', unit: '%', rankLink: 'humidity/' }
  }

  const fetchAmedasRank = async (id, areaType) => {
    const currentMonth = dayjs().month() + 1
    const element = typeof amedasElement[id].getEndpoint === 'function'
      ? amedasElement[id].getEndpoint(currentMonth)
      : amedasElement[id].endpoint
    try {
      const endpoint = getRankingDataUrl(withDomain, element, areaType)
      const { data } = await axios.get(endpoint)
      return data
    } catch (error) {
      return []
    }
  }

  const formatRank = (currentValue, prevValue, prevRank) => {
    if (prevValue === undefined || prevRank === undefined) {
      return 1
    }

    if (currentValue === prevValue) {
      return prevRank
    } else {
      return prevRank + 1
    }
  }

  const formatRegion = (pref) => {
    const region = pref.replace(/[県府都]$/, '')
    return region
  }

  const formatValue = (id, value) => {
    if (value === -9999) {
      return `--${amedasElement[id].unit}`
    } else if (value % 1 === 0 && id !== '湿度' && id !== '降雪量') {
      value = value.toFixed(1)
    }
    return `${value}${amedasElement[id].unit}`
  }

  const formatDate = (date) => {
    if (date === null) {
      return '---'
    } else if (date === undefined) {
      return
    }
    const formatedDate = dayjs.unix(date).format('HH:mm')
    if (formatedDate === '00:00') {
      return '24:00'
    }
    return formatedDate
  }

  const formatAmedasRank = (id, data, length) => {
    const formattedData = []
    for (let i = 0; i < length; i++) {
      formattedData.push({
        rank: formatRank(data[i].dataval, data[i - 1]?.dataval, formattedData[i - 1]?.rank),
        href: `https://weathernews.jp/onebox/amedas/${data[i].pref_roma}/${data[i].amedascode}/`,
        area: data[i].obsln,
        region: formatRegion(data[i].pref),
        value: formatValue(id, data[i].dataval),
        date: formatDate(data[i].occured_unixtime)
      })
    }
    return formattedData
  }

  const getAmedasRank = async ({ id, length, area, pref }) => {
    const data = await fetchAmedasRank(id, getAreaType(pref, area))
    if (data.length === 0) return []
    if (pref) {
      data.rank = data.rank.filter((rank) => rank.pref_roma === pref)
    } else if (area) {
      data.rank = data.rank.filter((rank) => rank.area_roma === area)
    }
    const formattedData = formatAmedasRank(id, data?.rank, length)
    return formattedData
  }

  const getRankingLink = ({ id, area, pref }) => {
    const detail = pref || area
    if (detail) {
      return `https://weathernews.jp/onebox/amedas/${detail}/${amedasElement[id].rankLink}ranking/`
    }
    return `https://weathernews.jp/onebox/amedas/${amedasElement[id].rankLink}ranking/`
  }

  const getAreaType = (pref, area) => {
    if (pref) {
      return 'pref'
    }
    if (area) {
      return 'area'
    }
    return 'japan'
  }

  const getRankingDataUrl = (domain, element, areaType) => {
    const fileName = areaType === 'japan' ? 'latest_top10.json' : 'latest.json'
    return `${domain}/info/data/obs/rank/${element}/${fileName}`
  }

  return { getAmedasRank, getRankingLink }
}
